import React from 'react';

export default function ArrowIcon(props) {
  return (
    <svg width={17} height={17} viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.47009 0H15.547C16.3495 0 17 0.650526 17 1.45299V14.5299C17 15.3324 16.3495 15.9829 15.547 15.9829C14.7445 15.9829 14.094 15.3324 14.094 14.5299V4.96082L2.48041 16.5744C1.91298 17.1419 0.993 17.1419 0.425571 16.5744C-0.141857 16.007 -0.141857 15.087 0.425571 14.5196L12.0392 2.90598H2.47009C1.66762 2.90598 1.01709 2.25546 1.01709 1.45299C1.01709 0.650526 1.66762 0 2.47009 0Z'
        fill='currentColor'
      />
    </svg>
  );
}
